import { getSelectedGeos } from '@utils/GeoUtils'
import { getCommonWidget, getLineTrendWidget } from '../dashWidgetHelper'
import { getLineDetailedRadar, radialMapperByIndicator } from '../widgetsLibrary/widgetsLine'
import { commonWidgets, OXXO_DEFAULT_COLORS, OXXO_DEFAULT_SCALE_3_COLORS, OXXO_COLORS_CONFIG_BAR } from './commonWidgetsOxxo'

export default {
  title: 'Gasolina Dashboard',
  description: 'Dashboard de perfil Gasolina',
  backgroundClassName: (filters) => 'epsilon-hero-bg',
  widgets: (filters: FiltersUI, filtersData: Record<string, any>) => {

    //console.log('TEST DASHBORD RENDER!!!!')
    const selGeos = getSelectedGeos(filtersData?.geographicDistributions, filters?.geographicDistributions)

    let level = undefined
    if (selGeos.length === 1) {
      if ([3, 6, 9].includes(selGeos[0]?.searchCodeFrom?.length)) {
        level = 4
      } else if (selGeos[0]?.searchCodeFrom?.length === 12) {
        level = 5
      }
    }

    //console.log(selGeos)
    //console.log(`manda level ${level}`)

    const geoGrupedCondition = level !== undefined
      ? { default: { group: 'formattedMonth,geoLocation', level: level } }
      : undefined

    return [
      getLineDetailedRadar({
        mainIndicator: 'satisfaction',
        mainIndicatorGral: 'satisfaction',
        radialIndicators: [
          'satisfaction',
          'service-speed',
          'alert-counters',
          'service',
          'willingness-to-recommend',
        ],
        size: [4, 4],
        title: 'Satisfacción General',
        extraConfigs: {
          backgroundColor: 'transparent',
          theme: 'dark',
          showRadialChart: true,
          colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.AMARILLO, OXXO_DEFAULT_COLORS.ROJO, OXXO_DEFAULT_COLORS.AZUL],
          decimals: 1,
          symbol: ''
        },
        criticalMomentInclude: [1],
        radialType: 'byIndicator',
        radialGrouped: {
          'alert-counters': 'geoLocation,alertStatus'
        },
        mapper: (data: any, extra: any) => {
          console.log('Satisfacción General radar oxxo mapper')
          console.log(data)
          return radialMapperByIndicator(data, extra)
        },
        indicatorsNames: {
          satisfaction: 'Satisfacción',
          service: 'Servicio',
          //'alert-counters-not-handled': '% Alertas sin gestión',
          'alert-counters-handled': '% Alertas en gestión',
          'service-speed': 'Rapidez',
          'willingness-to-recommend': 'NPS',
        },
        geoGrupedCondition: geoGrupedCondition
      }),
      {
        title: 'Mensual',
        type: 'label',
        position: [0, 3],
        size: [2, 1],
        config: { color: '#B7AADC' },
      },
      {
        title: 'Semanal',
        type: 'label',
        position: [2, 3],
        size: [2, 1],
        config: { color: '#B7AADC' },
      },
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'surveyLineTrendByMonth',
        title: 'Encuestas/Alertas por mes',
        size: [2, 2],
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.ROJO],
          //theme: 'dark',
        },
      }),


      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'surveyLineTrendByWeek',
        title: 'Encuestas/Alertas por semana',
        size: [2, 2],
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: [OXXO_DEFAULT_COLORS.VERDE, OXXO_DEFAULT_COLORS.ROJO],
          //theme: 'dark',
        },
      }),

      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'textAnalysis',
        size: [4, 4],
        indicator: 'sentiment',
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: OXXO_DEFAULT_SCALE_3_COLORS
        }
      }),
      {
        title: 'Tendencias',
        type: 'label',
        size: [4, 1],
      },
      getLineTrendWidget({
        title: 'Tendencias',
        indicators: ['satisfaction', 'service-speed', 'service', 'willingness-to-recommend'],
        groups: {
          satisfaction: 'Satisfacción',
          'service-speed': 'Indicador de Rapidez',
          service: 'Indicador de Atención',
          'willingness-to-recommend': 'NPS'
        },
        size: [3, 2],
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'multipleTrendByMonth',
        title: 'NPS',
        size: [1, 2],
        key: 'nps-multiple-trend-by-month',
        indicator: 'willingness-to-recommend',
        mapper: (data, extra) => {
          return data.map((item: any, idx: any) => ({
            ...item,
            groupName: item.groupName + ' (' + item.value + ')',
          }))
        },
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: OXXO_DEFAULT_SCALE_3_COLORS
        }
      }),
      {
        title: 'Estaciones',
        type: 'label',
        size: [4, 1],
      },
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'mapByGeos',
        title: 'Mapa de estaciones',
        size: [2, 2],
        indicator: 'willingness-to-recommend',
        criticalMomentInclude: [1],
        extraConfigs: {
          bestLocationValueFrom: 90,
          worstLocationValueTo: 90,
          colors: OXXO_COLORS_CONFIG_BAR,
          //sort: { sortBy: 'geo', value: 'asc', },
        }
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'rankingByGeoBest',
        title: 'Top 5 Mejores estaciones',
        size: [1, 2],
        extraConfigs: {
          backgroundColor: '#501C78',
          titleBackgroundColor: OXXO_DEFAULT_COLORS.VERDE,
          symbol: ''
        },
        indicator: 'satisfaction',
        criticalMomentInclude: [1],
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'rankingByGeoWorst',
        title: 'Bottom 5 Estaciones a mejorar',
        size: [1, 2],
        extraConfigs: {
          backgroundColor: '#501C78',
          titleBackgroundColor: OXXO_DEFAULT_COLORS.ROJO,
          symbol: '',
        },
        indicator: 'satisfaction',
        criticalMomentInclude: [1],
      }),
      {
        title: 'Sentimientos',
        type: 'label',
        size: [4, 1],
      },
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'pieGenericMedium',
        title: '¿Cuál (es) de estos servicios le ofrecieron?',
        size: [2, 2],
        indicator: 'ADDICIONAL_SERVICE_OPTIONS',
        criticalMomentInclude: [1],
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'pieGenericMedium',
        title: '¿Durante tu visita te ofrecieron alguno de los siguientes servicios complementarios?',
        size: [2, 2],
        indicator: 'COMPLEMENTARY_SERVICE_OPTIONS',
        criticalMomentInclude: [1],
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'rankingByTagBest',
        title: 'Sentimiento positivo con más frecuencia',
        size: [2, 1],
        indicator: 'sentiment',
        criticalMomentInclude: [1],
        extras: {
          trunc: 'HALF_DOWN',
          topSize: 3,
        },
        extraConfigs: {
          color: OXXO_DEFAULT_COLORS.VERDE
        }
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'rankingByTagWorst',
        title: 'Sentimiento negativo con más frecuencia',
        size: [2, 1],
        indicator: 'sentiment',
        criticalMomentInclude: [1],
        extras: {
          trunc: 'HALF_UP',
          bottomSize: 3,
        },
        extraConfigs: {
          color: OXXO_DEFAULT_COLORS.ROJO
        }
      }),


      {
        title: 'Diagrama de Ishikawa',
        type: 'label',
        size: [4, 1],
      },
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'diagramaIshikawa',
        //title: 'Diagrama Ishikawa',
        size: [4, 2],
        indicator: 'sentiment',
        criticalMomentInclude: [1],
      }),
      {
        title: 'Análisis',
        type: 'label',
        size: [4, 1],
      },
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'tagsAnalysis',
        title: 'Análisis de comentarios negativos',
        size: [4, 4],
        key: 'tags-analysis-negative-gasolina',
        //indicator: 'sentiment',
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: OXXO_DEFAULT_SCALE_3_COLORS,
          rankByScore: true,
          commentType: 'negative',
          commentsLimit: 5
        },
        extras: {
          numberAnswerTo: 0
        }
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'tagsAnalysis',
        title: 'Análisis de comentarios positivos',
        size: [4, 4],
        key: 'tags-analysis-positive-gasolina',
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: OXXO_DEFAULT_SCALE_3_COLORS,
          showGeoLocation: true,
          rankByScore: true,
          commentType: 'positive',
          commentsLimit: 5
        },
        extras: {
          numberAnswerFrom: 1
        }
      }),
      {
        title: 'Tiempos de respuesta',
        type: 'label',
        size: [4, 1],
      },

      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'alertFirstResponseBarByWeek',
        indicator: 'alert-first-response-time',
        title: 'Tiempo de respuesta alertas semanal. Base 36 hs.',
        size: [4, 2],
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: {
            slowPerc: OXXO_DEFAULT_COLORS.ROJO,
            fastPerc: OXXO_DEFAULT_COLORS.VERDE
          }
        }
      }),

      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'alertFirstResponseBarByMonth',
        indicator: 'alert-first-response-time',
        title: 'Tiempo de respuesta alertas mensual. Base 36 hs.',
        size: [4, 2],
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: {
            slowPerc: OXXO_DEFAULT_COLORS.ROJO,
            fastPerc: OXXO_DEFAULT_COLORS.VERDE
          }
        }
      }),
      getCommonWidget({
        commonWidgets: commonWidgets,
        name: 'alertFirstResponseBarByGeo',
        title: 'Tiempo de respuesta alertas por geo. Base 36 hs.',
        size: [4, 2],
        criticalMomentInclude: [1],
        extraConfigs: {
          colors: {
            slowPerc: OXXO_DEFAULT_COLORS.ROJO,
            fastPerc: OXXO_DEFAULT_COLORS.VERDE
          }
        }
      }),
    ]
  },
} as DasboardConfig
